import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/** SUBMITTED → DRAFT。 */
export async function rejectStockAdjustment(id, payload) {
  const { data: raw } = await request.post(
    `/ims/stock-adjustment/${id}/reject`,
    keysToSnake(payload),
  );
  return parseVer4DetailResponse(raw);
}
